<!-- static content data from lang: assign_questionnaire -->
<template>
    <div>
        <base-header class="pb-6" v-loading="loading">
            <div class="row align-items-center pb-4">
                <div class="col-lg-12 col-12">
                    <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.AddheaderTitle}}</h6>
                    <nav aria-label="breadcrumb" class="d-inline-block ml-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
                <div class="col-md-12">
                  <template v-for="(message) in alertMessages">
                    <Alert :type = alertType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
                  </template>
                  <template v-for="(message) in successMessages">
                    <Alert :type = successType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
                  </template>
                    <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                        <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input :label="lang.label.site" name="site" :rules="{required: true}" labelClasses="form-control-label asterisk-mark">
                                                <el-select v-model="model.site" autocomplete="off" filterable>
                                                    <el-option
                                                        v-for="(option,index) in site"
                                                        :key="index"
                                                        :label="option.Name"
                                                        :value="option.ID"
                                                        >
                                                    </el-option>
                                                </el-select>
                                            </base-input>
                                        </div>
                                        <div class="col-md-6">
                                            <base-input :label="lang.label.questionnaire" name="questionary" :rules="{required: true}" labelClasses="form-control-label asterisk-mark">
                                                <el-select v-model="model.questionary" autocomplete="off" filterable>
                                                    <el-option
                                                        v-for="(option,index) in questionary"
                                                        :key="index"
                                                        :label="option.Name"
                                                        :value="option.ID"
                                                        >
                                                        <!--                            <slot>{{option.Name}}</slot>-->
                                                    </el-option>
                                                </el-select>
                                            </base-input>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label
                                                    class="form-control-label"
                                                    >{{lang.label.isActive}}</label>
                                                <div>
                                                {{switches.off}}
                                                    <base-switch v-model="switches.off" class="mr-1" on-text="Yes" off-text="No"></base-switch>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="text-right mb-3">
                                <base-button type="primary" native-type="submit">{{lang.label.buttons.save}}</base-button>
                                <base-button
                                    type="danger"
                                    @click="$router.push({name: 'assignQuestionnaires'})"
                                    >{{lang.label.buttons.cancel}}</base-button>
                            </div>
                        </form>
                    </validation-observer>
                </div>
                </card>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import { Select, Option } from "element-ui";
    import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
    import {mapGetters} from "vuex";
    import Alert from "@/components/BaseAlert.vue";

    export default {
        components: {
            [Select.name]: Select,
            [Option.name]: Option,
            RouteBreadCrumb,
              Alert
        },
        data() {
            return {
                loading: true,
                switches: {
                    off: false,
                    on: true
                },
                lang: this.$lang.assign_questionnaire,
                model: {
                    site: "",
                    companyName: ""
                },
                selects: {
                    simple: "Select"
                },
                site: [],
                questionary: [],
                alertType: 'danger',
                successType: 'success',
                alertMessages: [],
                successMessages: [],
            };
        },
        computed: {
            ...mapGetters({
                    login: "login",
                    unauthorized: "unauthorized",
            }),
            question() {
                return this.model.site;
            }
        },
        mounted() {
            this.getSites(this.login.CompanyID);
            this.getQuestionnaires();
        },
        methods: {
            getSites(val) {
                let self = this;
                self.loading = true;
                this.$store.dispatch('getSiteUponCompany', val).then(response => {
                    self.site = response;
                    self.loading = false;
                });
            },
            getQuestionnaires() {
                this.loading = true;
                this.$store.dispatch('questionnairesList').then(response => {
                    this.questionary = response.data;
                    this.loading = false;
                });
            },
            onSubmit() {
                let self = this;
                this.loading = true;
                let data = {
                    CompanySitesID: self.model.site,
                    CompanyQuestionnaireID: self.model.questionary,
                    IsActive: this.switches.off ? "1" : "0",
                };
                this.$store.dispatch('addQuestionnaire', data).then(response => {
                    if (response.status == 200) {
                        this.loading = false;
                        this.flash({message: response.data.message, variant: 'success'});
                        self.$router.push({path: "list"});
                    } else {
                        if(typeof response.data.message != 'object'){
                            this.alertMessages.push(response.data.message);
                        }else{
                            let array = new Array();
                            for (let key of Object.keys(response.data.message)) {
                                let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                array.push(obj)
                            }
                            self.alertMessages.push(array.join(', '));
                            setTimeout(function () {
                                self.alertMessages = [];
                            },5000)
                        }
                        this.loading = false;
                    }
                });

            }
        }
    };
</script>
<style>
    .no-border-card .card-footer {
        border-top: 0;
    }
    .modal-header {
        padding-bottom: 0;
    }
</style>
